import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { WoundService } from 'src/app/services/wound.service';
import { WoundCareWidgetService } from '../wound-care-widget.service';
import { WoundDiagnosis, WoundICD10DialogComponent } from '../wound-icd10-dialog/wound-icd10-dialog.component';
import { getFieldName } from '../wound-utils';
import * as global from "../../../../includes/global";
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-create-wound-dialog',
  templateUrl: './create-wound-dialog.component.html',
  styleUrls: ['./create-wound-dialog.component.css']
})
export class CreateWoundDialogComponent implements OnInit {
  global = global;
  loaderId = 'create-wound-dialog-loader';
  provider;
  patient;
  wound;
  childWound;
  dataset: any[] = [];
  allDataSet: any[] = [];
  selected: any = [];
  todayDate: Date | moment.Moment;
  selectedDataset = {
    etiolgy: '',
    body_part: '',
    stage: '',
    body_side: '',
    state: '',
    direction: '',
    exposed_tissues: '',
    periwound: '',
    eschar: '',
    granulation: '',
    slough: '',
    epithelial: '',
    infection_signs: '',
    exudate_type: '',
    exudate: '',
    exposed_structure: '',
    odor: '',
    wound_recognition_date: null,
    wound_recognition_date_type: '',
    pain: '',
    primary_treatment: '',
    change_frequency: '',
    secondary_dressing: '',
    'pressure_reduction/off_loading': '',
    cleanse_wound_with: '',
    dressings: '',
    bacterial_fluorescent_imaging: '',
    goal_of_care: '',
    specialty_treatment: "",
    cover_dressing: "",
    compression: "",
    camp_application: "",
    moisture_management: "",
    infection_management: "",
    biofilm_management: "",
    periwound_treatment: "",
    change: "",
    parameter: "",
  }
  pagination = {
    pageNo: 1,
    hasNextPage: false,
    hasPrevPage: false,
    totalRecords: null,
    PAGE_LIMIT: 10,
    skip: 0,
    dataSet: '1'
  };
  selectedDatasetInLatestChildWound = {
    stage: ''
  }
  selectedState: string = "";
  selectedStage: string = "";
  laterality = [
    'R',
    'L',
    'BL'
  ]
  disabledDataset: any = {};
  disabledDatasetInLatestChildWound: any = {};
  woundLocked = false;

  onICDsSave: EventEmitter<any> = new EventEmitter();

  woundDiagnosis: WoundDiagnosis;
  oldselectedDataset: any;
  oldselectedDatasetInLatestChildWound: any;
  avatar: Boolean = false;
  avatarMsg: String = "Show Avatar";
  selectedNext: boolean = false;
  showDataSet_1: boolean = false;
  skipRecords: number;
  previousValue: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  freeTextFieldData = {};
  currentuser: any;
  constructor(
    private loader: NgxUiLoaderService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateWoundDialogComponent>,
    private woundCareWidgetService: WoundCareWidgetService,
    private woundService: WoundService,
    private _authService: AuthService,
    private _commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data) {
      this.provider = data.provider;
      this.patient = data.patient;
      if(data.wound !== null ){
        this.wound = data.wound;
      }else{
        this.wound = data.childWound;
      }
      console.log("Wound Data", data.childWound, this.wound);
      this.selectedState = this.wound.state;
      this.childWound = data.childWound;
      this.onICDsSave = data.onICDsSave;
      for (const key in this.wound) {
        if (Object.prototype.hasOwnProperty.call(this.selectedDataset, key)) {
          this.selectedDataset[key] = this.wound[key];
          if (this.isArchivedWound() && key === 'state') {
            this.disabledDataset[key] = false;
          } else {
            this.disabledDataset[key] = this.isArchivedWound() || !!this.wound[key];
          }
        } else {
          console.log(key, 'missing from selectedDataset')
        }
      }
      if (this.hasLatestChildWound()) {
        for (const key in this.childWound) {
          if (Object.prototype.hasOwnProperty.call(this.selectedDatasetInLatestChildWound, key)) {
            this.selectedDatasetInLatestChildWound[key] = this.childWound[key];
            if (this.isArchivedWound() && key === 'state') {
              this.disabledDatasetInLatestChildWound[key] = false;
            } else {
              this.disabledDatasetInLatestChildWound[key] = this.isArchivedWound() || !!this.childWound[key];
            }
          } else {
            // console.log(key, 'missing from selectedDatasetInLatestChildWound')
          }
        }
      }



      if (!this.selectedDataset.wound_recognition_date) {
        if (this.patient.pcc_payload) {
          this.selectedDataset.wound_recognition_date = moment(this.patient.pcc_payload.admissionDate).format('MM/dd/yyyy');
        } else {
          this.selectedDataset.wound_recognition_date = new Date();
        }
      }
      this.oldselectedDataset = { ...this.selectedDataset };
      this.oldselectedDatasetInLatestChildWound = { ...this.selectedDatasetInLatestChildWound };
    }
    this.todayDate = this.wound.wound_recognition_date ? moment(this.wound.wound_recognition_date) : new Date();
    this.currentuser = this._authService.currentUser;
  }

  async ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(async () => {
      if (!(JSON.stringify(this.selectedDataset) === JSON.stringify(this.oldselectedDataset)) || !(JSON.stringify(this.oldselectedDatasetInLatestChildWound) === JSON.stringify(this.selectedDatasetInLatestChildWound))) {
        this.updateWoundData();
      }
    });
    this.loader.startLoader(this.loaderId);
    this.initWoundDiagnosis();

    const loaderInstance = this.loader.getLoader(this.loaderId);
    const { status, data } = await lastValueFrom(this.woundCareWidgetService.getAllDataset(this.provider.company_id, {}, "1"));
    if (status == 200) {
      this.allDataSet = data;
      this.dataset = data.filter((set) => set.user_types.includes(this.currentuser.user_type));
    }
    this.allDataSet.forEach((set)=>{
      if(set.multiselect_enabled === false){
        let fieldName = this.getFieldName(set.header);
        if (fieldName === 'wound_edges') {
          fieldName = 'exposed_structure';
        } else if (fieldName === 'exudate_amount') {
          fieldName = 'exudate';
        } else if (fieldName === 'wound_odor') {
          fieldName = 'odor';
        }
        this.freeTextFieldData[fieldName] = this.selectedDataset[fieldName];
      }
    });
    this.loader.stopLoader(this.loaderId);

  }
  async initDataset(dataSet, page) {
    this.loader.startLoader(this.loaderId);
    let { status, data, totalRecords } = await lastValueFrom(this.woundCareWidgetService.getAllDataset(this.provider.company_id, {}, dataSet, page));
    if (status == 200) {
      data = data.filter((set) => set.user_types.includes(this.currentuser.user_type));
      this.allDataSet = data;
      this.dataset = data;
      if(dataSet == "2"){
        this.pagination.totalRecords = totalRecords;
      }
      this.reArrangeDataSet();
      this.allDataSet.forEach((set)=>{
        if(set.multiselect_enabled === false){
          let fieldName = this.getFieldName(set.header);
          if (fieldName === 'wound_edges') {
            fieldName = 'exposed_structure';
          } else if (fieldName === 'exudate_amount') {
            fieldName = 'exudate';
          } else if (fieldName === 'wound_odor') {
            fieldName = 'odor';
          }
          this.freeTextFieldData[fieldName] = this.selectedDataset[fieldName];
        }
      });
      this.loader.stopLoader(this.loaderId);
    }
  }
  async getNextDataSet() {
    if (this.pagination.dataSet == "2") {
      this.pagination.pageNo++;
    } else {
      this.pagination.dataSet = "2"
    }
    this.pagination.skip = (this.pagination.pageNo-1)*this.pagination.PAGE_LIMIT;
    await this.initDataset(this.pagination.dataSet, this.pagination.pageNo);
  }
  async getPrevDataSet() {
    if (this.pagination.dataSet == "2") {
      this.pagination.pageNo--;
      if (this.pagination.pageNo == 0) {
        this.pagination.pageNo = 1;
        this.pagination.dataSet = "1"
        this.pagination.totalRecords = null;
      }
    }
    this.pagination.skip = (this.pagination.pageNo-1)*this.pagination.PAGE_LIMIT;
    await this.initDataset(this.pagination.dataSet, this.pagination.pageNo);
  }
  showNextButton() {
    if(this.pagination.totalRecords == null){
      return true;
    }else{
      if(this.pagination.skip+this.dataset.length < this.pagination.totalRecords){
        return true;
      }else{
        return false;
      }
    }
  }
  reArrangeDataSet() {
    let indexArray = new Array<number>(this.dataset.length);
    let x = 0;
    let predefinedHeaders = ['Epithelial', 'Granulation', 'Slough', 'Eschar', 'Wound Edges', 'Periwound'];
  
    for (let i = 0; i < predefinedHeaders.length; i++) {
      let header = predefinedHeaders[i];
      let headerIndex = this.dataset.findIndex(set => set.header === header);
      if (headerIndex !== -1) {
        indexArray[headerIndex] = i;
      }
    }
  
    for (let i = 0; i < this.dataset.length; i++) {
      if (typeof indexArray[i] === 'undefined') {
        indexArray[i] = x + predefinedHeaders.length;
        x++;
      }
    }
  
    let temp = [...Array(this.dataset.length)];
    for (let i = 0; i < this.dataset.length; i++) {
      temp[indexArray[i]] = this.dataset[i];
    }
    this.dataset = temp.filter((ele)=> ele !== undefined);
  }
  // async getNextWoundData(action){
  //   // this.selectedNext = !this.selectedNext;
  //   if(this.selectedNext){
  //     this.dataset = this.allDataSet.filter((set)=> set.dataSet == "2")
  //     let indexArray =  new Array<number>(this.dataset.length);
  //     let x = 0;
  //     this.dataset.forEach((set,index)=>{
  //       if(set.header == 'Epithelial'){
  //         x++;
  //       }else if(set.header == 'Granulation'){
  //         x++;
  //       }else if(set.header == 'Slough'){
  //         x++;
  //       }else if (set.header == 'Eschar'){
  //         x++;
  //       }else if(set.header == 'Wound Edges'){
  //         x++;
  //       }else if(set.header == 'Periwound'){
  //         x++;
  //       }
  //     });

  //     this.dataset.forEach((set,index)=>{
  //       if(set.header == 'Epithelial'){
  //         indexArray[index] = 0
  //       }else if(set.header == 'Granulation'){
  //         indexArray[index] = 1
  //       }else if(set.header == 'Slough'){
  //         indexArray[index] = 2
  //       }else if (set.header == 'Eschar'){
  //         indexArray[index] = 3
  //       }else if(set.header == 'Wound Edges'){
  //         indexArray[index] = 4
  //       }else if(set.header == 'Periwound'){
  //         indexArray[index] = 5
  //       }else{
  //         indexArray[index] = x;
  //         x++;
  //       }
  //     });
  //     var temp = [...Array(this.dataset.length)];
  //     for (var i = 0; i < this.dataset.length; i++) temp[indexArray[i]] = this.dataset[i];
  //     for (var i = 0; i < this.dataset.length; i++) {
  //       this.dataset[i] = temp[i];
  //       indexArray[i] = i;
  //     }
  //   }else{
  //     this.dataset = this.allDataSet.filter((set)=> set.dataSet == "1")
  //   }
  // }
  async initWoundDiagnosis() {
    const { data, status } = await lastValueFrom(this.woundService.getWoundDiagnosis(this.wound._id)) as any;

    if (status == 200 && data) {
      this.woundDiagnosis = data;
    }
  }
  displayItem(item) {
    switch (item.data_type) {
      case 'Text':
        return item.value;

      case 'Dropdown':
        return
    }
  }

  toggleSelect(data) {
    if (this.selected.indexOf(data) === -1) {
      this.selected.push(data);
    } else {
      const i = this.selected.indexOf(data);
      this.selected.splice(i, 1);
    }
  }
  isSelected(data) {
    const i = this.selected.indexOf(data);
    return i > -1;
  }

  isFieldValid(header) {
    const fieldName = this.getFieldName(header);
    return !!this.selectedDataset[fieldName];
  }
  isFieldValidInLatestChildWound(header) {
    const fieldName = this.getFieldName(header);
    return !!this.selectedDatasetInLatestChildWound[fieldName];
  }

  isFieldValueSelected(value, header, multiselect_enabled) {
    if (typeof value === 'string') value = value.trim();
    let fieldName = this.getFieldName(header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    let selectedValue = this.selectedDataset[fieldName];
    if (typeof selectedValue === 'string') selectedValue = selectedValue.trim();
    if (multiselect_enabled) {
      let values = this.selectedDataset[fieldName]?.split(', ') || [];
      const valueIndex = values.indexOf(value);
      return valueIndex >= 0;
    }
    if (fieldName === 'wound_diagnosis') {
      return !!this.wound[fieldName];
    } else {
      if (typeof (value) === 'object') {
        return value.includes(this.selectedDataset[fieldName])
      }
      return selectedValue === value;
    }
  }
  isFieldValueSelectedInLatestChildWound(value, header, multiselect_enabled) {
    if (typeof value === 'string') value = value.trim();
    let fieldName = this.getFieldName(header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if (multiselect_enabled) {
      let values = this.selectedDatasetInLatestChildWound[fieldName]?.split(', ') || [];
      const valueIndex = values.indexOf(value);
      return valueIndex >= 0;
    } if (fieldName === 'wound_diagnosis') {
      return !!this.childWound[fieldName];
    } else {
      return this.selectedDatasetInLatestChildWound[fieldName] === value;
    }
  }
  selectFieldValueInLatestChildWound(value, header, multiselect_enabled) {
    let fieldName = this.getFieldName(header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if (typeof value === 'string') value = value.trim()
    // if (this.disabledDatasetInLatestChildWound[fieldName]) return;
    if (this.isEditingLocked()) return;

    if (multiselect_enabled) {
      let values = this.selectedDatasetInLatestChildWound[fieldName]?.split(', ') || [];
      const valueIndex = values.indexOf(value);
      if (valueIndex >= 0) {
        values.splice(valueIndex, 1);
      } else {
        values.push(value);
      }
      let commaSeperated: any = Array.from(new Set(values.filter(e => !!e)));
      commaSeperated = commaSeperated.length === 1 ? commaSeperated[0] : commaSeperated.join(', ');
      this.selectedDatasetInLatestChildWound[fieldName] = commaSeperated
    } else {
      this.selectedDatasetInLatestChildWound[fieldName] = value;
      if (fieldName === 'stage') {
        this.selectedStage = value
      }
      if (fieldName === 'wound_recognition_date_type' && this.selectedDataset[fieldName] === 'present_on_admission') {
        let admitDateObj = null;
        if (this.patient.last_admit_date_obj) {
          let year = this.patient.last_admit_date_obj.year;
          let month = this.patient.last_admit_date_obj.month;
          let day = this.patient.last_admit_date_obj.day;
          if (month < 10) { month = '0' + month; }
          if (day < 10) { day = '0' + day; }
          admitDateObj = (month + '/' + day + '/' + year);
        } else if (this.patient.last_admit_date) {
          admitDateObj = moment.tz(this.patient.last_admit_date, "UTC").format('MM/DD/YYYY');
        } else if (this.patient.pcc_payload?.admissionDate) {
          admitDateObj = this.patient.pcc_payload?.admissionDate;
        }
        this.selectedDatasetInLatestChildWound['wound_recognition_date'] = new Date(admitDateObj);
      } else if (fieldName === 'wound_recognition_date_type' && this.selectedDataset[fieldName] === 'facility_aquired') {
        this.selectedDatasetInLatestChildWound['wound_recognition_date'] = this.todayDate;
      }
    }
  }
  selectFieldValue(value, header, multiselect_enabled) {
    if (header == 'state') {
      this.selectedState = value;
    }
    let fieldName = this.getFieldName(header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if (typeof value === 'string') value = value.trim();
    // if (fieldName !== 'state' && this.disabledDataset[fieldName]) return;
    if (fieldName !== 'state' && this.isEditingLocked()) return;

    if (fieldName != 'etiolgy' && fieldName != 'stage' && fieldName != 'state' && fieldName != 'wound_recognition_date_type' && this.selectedDataset[fieldName] == value) {
      this.selectedDataset[fieldName] = '';
      return;
    }
    if(multiselect_enabled){
      let values = this.selectedDataset[fieldName]?.split(', ') || [];
      const valueIndex = values.indexOf(value);
      if (valueIndex >= 0) {
        values.splice(valueIndex, 1);
      } else {
        values.push(value);
      }
      let commaSeperated: any = Array.from(new Set(values.filter(e => !!e)));
      commaSeperated = commaSeperated.length === 1 ? commaSeperated[0] : commaSeperated.join(', ');
      this.selectedDataset[fieldName] = commaSeperated
    }else{
      if (fieldName === 'body_side') {
        if (this.selectedDataset[fieldName] === value) {
          this.selectedDataset[fieldName] = null;
        } else {
          this.selectedDataset[fieldName] = value;
        }
      } else {
        if (fieldName === 'stage') {
          this.selectedStage = value
        }
        if (this.selectedDataset[fieldName] === value) {
          this.selectedDataset[fieldName] = '';
        } else {
          this.selectedDataset[fieldName] = value;
        }
        if (fieldName === 'wound_recognition_date_type' && this.selectedDataset[fieldName] === 'present_on_admission') {
          let admitDateObj = null;
          if (this.patient.last_admit_date_obj) {
            let year = this.patient.last_admit_date_obj.year;
            let month = this.patient.last_admit_date_obj.month;
            let day = this.patient.last_admit_date_obj.day;
            if (month < 10) { month = '0' + month; }
            if (day < 10) { day = '0' + day; }
            admitDateObj = (month + '/' + day + '/' + year);
          } else if (this.patient.last_admit_date) {
            admitDateObj = moment.tz(this.patient.last_admit_date, "UTC").format('MM/DD/YYYY');
          } else if (this.patient.pcc_payload?.admissionDate) {
            admitDateObj = this.patient.pcc_payload?.admissionDate;
          }
          this.selectedDataset['wound_recognition_date'] = new Date(admitDateObj);
        } else if (fieldName === 'wound_recognition_date_type' && this.selectedDataset[fieldName] === 'facility_aquired') {
          this.selectedDataset['wound_recognition_date'] = this.todayDate;
        }
      }
    }
  }
  handleCustomTextChangeinParent(column, value, multiselect_enabled) {
    let fieldName = this.getFieldName(column.header);
    const headerRowsValues = column.rows.map((row)=> row.value);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if (multiselect_enabled) {
      if (value == '') {
        const prevFieldValues = this.previousValue.split(', ').map(e => e.trim()).filter(e => !!e);
        let prevValues = this.selectedDataset[fieldName].split(', ').map(e => e.trim()).filter(e => !!e);
        prevValues.forEach((v, index) => {
          if (prevFieldValues.includes(v)) {
            prevValues.splice(index, 1);
          }
        });
        this.selectedDataset[fieldName] = prevValues.map(e => e.trim()).filter(e => !!e).join(', ');
      } else {
        if (value[value.length - 1] === ',') {
          const fieldValues = value.split(', ').map(e => e.trim()).filter(e => !!e);
          const prevValues = this.selectedDataset[fieldName].split(', ').map(e => e.trim()).filter(e => !!e);
          for (const value of fieldValues) {
            if (prevValues.indexOf(value) === -1) {
              prevValues.push(value.substring(0, value.length - 1));
            }
          }
          this.selectedDataset[fieldName] = prevValues.map(e => e.trim()).filter(e => !!e).join(', ');
        }
      }
    } else {
      if (fieldName === 'stage') {
        this.selectedStage = value
      }
      const headerRowValueIndex = headerRowsValues.findIndex((rvalue)=> typeof(rvalue) === "string" && rvalue.trim().toLowerCase() === value.trim().toLowerCase());
      if(headerRowValueIndex === -1){
        this.selectedDataset[fieldName] = value;
        this.freeTextFieldData[fieldName] = value;
      }else{
        this.selectedDataset[fieldName] = headerRowsValues[headerRowValueIndex];
        this.freeTextFieldData[fieldName] = ""
      }
    }
  }
  handleCustomTextChangeinlatestChild(header, value, multiselect_enabled) {
    let fieldName = this.getFieldName(header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if (multiselect_enabled) {
      if (value == '') {
        const prevFieldValues = this.previousValue.split(', ').map(e => e.trim()).filter(e => !!e);
        let prevValues = this.selectedDatasetInLatestChildWound[fieldName].split(', ').map(e => e.trim()).filter(e => !!e);
        prevValues.forEach((v, index) => {
          if (prevFieldValues.includes(v)) {
            prevValues.splice(index, 1);
          }
        });
        this.selectedDatasetInLatestChildWound[fieldName] = prevValues.map(e => e.trim()).filter(e => !!e).join(', ');
      } else {
        if (value[value.length - 1] === ',') {
          const fieldValues = value.split(', ').map(e => e.trim()).filter(e => !!e);
          const prevValues = this.selectedDatasetInLatestChildWound[fieldName].split(', ').map(e => e.trim()).filter(e => !!e);
          for (const value of fieldValues) {
            if (prevValues.indexOf(value) === -1) {
              prevValues.push(value.substring(0, value.length - 1));
            }
          }
          this.selectedDatasetInLatestChildWound[fieldName] = prevValues.map(e => e.trim()).filter(e => !!e).join(', ');
        }
      }
    } else {
      if (fieldName === 'stage') {
        this.selectedStage = value
      }
      this.selectedDatasetInLatestChildWound[fieldName] = value;
    }
  }
  handleCustomTextChange(value, header) {
    const fieldName = this.getFieldName(header);
    if (fieldName === 'direction' || fieldName === 'infection_signs' || fieldName === 'periwound' || fieldName === 'periwound'|| fieldName == 'change_frequency' || fieldName == 'secondary_dressing' || fieldName == 'primary_treatment') {
      const fieldValues = value.split(', ').map(e => e.trim()).filter(e => !!e);
      const prevValues = this.selectedDataset[fieldName].split(', ').map(e => e.trim()).filter(e => !!e);
      for (const value of fieldValues) {
        if (prevValues.indexOf(value) === -1) {
          prevValues.push(value)
        }
      }
      this.selectedDataset[fieldName] = prevValues.map(e => e.trim()).filter(e => !!e).join(', ');
    } else {
      this.selectedDataset[fieldName] = value;
    }
  }
  getHeaderName(header) {
    const headerName = this.getFieldName(header, true)
    if (headerName == "Wound_status") {
      return 'STATUS'
    } else if (headerName == "Stage") {
      return 'SEVERITY';
    } else if (headerName == "Body_part") {
      return 'LOCATION'
    } else if (headerName == 'Odor') {
      return 'ODOR POST CLEANSING';
    } else if (headerName == 'Exudate_type') {
      return 'EXUDATE DESCRIPTION';
    } else if(headerName == 'Etiolgy'){
      return 'ETIOLOGY'
    } else if(headerName == 'Exposed_tissues'){
      return 'EXPOSED STRUCTURE'
    }else {
      let $nameWithout_ = headerName.split('_');
      let fullHeaderName = '';
      $nameWithout_.forEach((n, index) => {
        if (index == 0) {
          fullHeaderName = n
        } else {
          fullHeaderName += ' ' + n;
        }
      });
      return fullHeaderName.toUpperCase();
    }
  }
  getFieldName(header, firstLetterUppercase = false) {
    if (firstLetterUppercase) {
      let name = getFieldName(header).substr(0, 18)
      return name.charAt(0).toUpperCase() + name.slice(1)
    } else {
      return getFieldName(header)
    }
  }

  getCustomTextValue(header, multiselect_enabled, checkFreeText = true) {
    const fieldName = this.getFieldName(header);
    let value = '';
    if (fieldName === 'wound_edges') {
      value = this.selectedDataset['exposed_structure'] || '';
    } else if (fieldName === 'exudate_amount') {
      value = this.selectedDataset['exudate'] || '';
    } else if (fieldName === 'wound_odor') {
      value = this.selectedDataset['odor'] || '';
    } else {
      value = this.selectedDataset[fieldName] || '';
    }

    if (checkFreeText && this.freeTextFieldData && this.freeTextFieldData[fieldName]) {
      value = this.freeTextFieldData[fieldName];
    }

    const column = this.dataset.find(column => column.header === header);
    if (!column || !column.rows) return '';
    if (!value) return '';

    if (multiselect_enabled) {
      const newValues = typeof value === 'string' ? value.split(', ') : [];
      for (const data of column.rows) {
        const index = newValues.findIndex(v => v === data.value.trim());
        if (index >= 0) {
          newValues.splice(index, 1);
        }
      }
      return newValues.filter(v => !!v).join(', ');
    } else {
      if (typeof value === 'string') {
        for (const data of column.rows) {
          if (typeof data.value === 'string') {
            if (data.value.trim() === value.trim()) {
              return '';
            }
          } else {
            if (data.value.includes(value)) {
              return '';
            } else {
              return value;
            }
          }
        }
      }
    }
    return value;
  }
  handleSelection(header, $event) {
    const fieldName = this.getFieldName(header);
    this.selectedDataset[fieldName] = $event.value;
  }
  getSelectedValue(header) {
    const fieldName = this.getFieldName(header);
    return this.selectedDataset[fieldName];
  }
  getCustomTextValueInLatestChildWound(header, multiselect_enabled) {
    const fieldName = this.getFieldName(header);
    let value = '';
    if (fieldName === 'wound_edges') {
      value = this.selectedDatasetInLatestChildWound['exposed_structure'] || '';
    } else if (fieldName === 'exudate_amount') {
      value = this.selectedDatasetInLatestChildWound['exudate'] || '';
    } else if (fieldName === 'wound_odor') {
      value = this.selectedDatasetInLatestChildWound['odor'] || '';
    } else {
      value = this.selectedDatasetInLatestChildWound[fieldName] || '';
    }
    const column = this.dataset.find(column => column.header === header);
    if (!column || !column.rows) return '';
    if (!value) return '';

    if (multiselect_enabled) {
      const newValues = value.split(', ');
      for (const data of column.rows) {
        const index = newValues.findIndex(v => v === data.value.trim());
        if (index >= 0) {
          newValues.splice(index, 1);
        }
      }
      return newValues.filter(v => !!v).join(', ');
    } else {
      if (typeof value === 'string') {
        for (const data of column.rows) {
          if (typeof data.value === 'string') {
            if (data.value.trim() === value.trim()) {
              return '';
            }
          } else {
            if (data.value.includes(value)) {
              return '';
            } else {
              return value;
            }
          }
        }
      }
    }
    return value;
  }
  allFieldsValid() {
    return [this.selectedDataset['wound_recognition_date_type'], ...Object.values(this.selectedDataset)].every(field => !!field)
  }
  showButtons(header){
    let inputField = jQuery(`#${header}`).val();
    if(inputField && inputField.toString().length > 0){
      return true
    }else{
      return false;
    }
  }
  removeFreeTextValue(header){
    jQuery(`#${header}`).val("");
  }
  async updateWoundData() {
    if (this.isEditingLocked()) {
      const { status, data } = await lastValueFrom(this.woundCareWidgetService.updateWoundData(this.wound._id, {
        state: this.selectedDataset.state
      }));
      if (status == 200) {
        this.updateWoundObj(data);
        this.wound['state'] = this.selectedDataset['state'];
      }
      return;
    };
    const { status, data } = await lastValueFrom(this.woundCareWidgetService.updateWoundData(this.wound._id, this.selectedDataset));
    if (status == 200) {
      this.updateWoundObj(data);
      for (const key in this.selectedDataset) {
        if (Object.prototype.hasOwnProperty.call(this.selectedDataset, key)) {
          this.wound[key] = this.selectedDataset[key];
        }
      }
    }
    if (this.hasLatestChildWound()) {
      let updateData = {};
      for (const key in this.selectedDataset) {
        if (Object.prototype.hasOwnProperty.call(this.selectedDataset, key)) {
          const value = this.selectedDataset[key];
          if (this.oldselectedDataset[key] !== value) {
              updateData[key] = value
          }
        }
      }
      for (const key in this.selectedDatasetInLatestChildWound) {
        if (Object.prototype.hasOwnProperty.call(this.selectedDatasetInLatestChildWound, key)) {
          const value = this.selectedDatasetInLatestChildWound[key];
          if (key !== 'stage' && this.oldselectedDatasetInLatestChildWound[key] !== value) {
              updateData[key] = value
          }
        }
      }
      if (this.selectedStage != "") {
        updateData['stage'] = this.selectedStage;
      }
      const { status, data } = await lastValueFrom(this.woundCareWidgetService.updateWoundData(this.childWound._id, updateData));
      if (status == 200) {
        for (const key in this.selectedDatasetInLatestChildWound) {
          if (Object.prototype.hasOwnProperty.call(this.selectedDatasetInLatestChildWound, key)) {
            this.childWound[key] = this.selectedDatasetInLatestChildWound[key];
          }
        }
      }
    }
  }
  updateWoundObj(wound) {
    const { updatedAt, wound_recognition_date_type, wound_recognition_date } = wound;
    const [year, month, day] = this._commonService.convertDateToStringforMoment(moment(updatedAt)).split("-");
    this.wound.updated_At = `${month}/${day}/${year}`;
    this.wound.wound_recognition_date_type = wound_recognition_date_type;
    if (wound_recognition_date)
      this.wound.wound_recognition_date = moment(wound_recognition_date);
  }
  async updateWoundDataAndClose() {
    let loc = this.selectedDataset['body_side'] === "R" ? "Right " : this.selectedDataset['body_side'] === "L" ? "Left " : this.selectedDataset['body_side'] === "BL" ? "Bilateral " : "";
    let updateData = {};
    for (const key in this.selectedDataset) {
      if (Object.prototype.hasOwnProperty.call(this.selectedDataset, key)) {
        const value = this.selectedDataset[key];
        if (key !== 'direction' && key !== 'body_part' && key !== 'body_side' && key !== 'stage' && key !== 'state' && key !== 'wound_recognition_date' && key !== 'wound_recognition_date_type') {
          if (this.oldselectedDataset[key] !== value) {
            if (key === 'etiolgy') {
              updateData['etiology'] = value
            } else {
              updateData[key] = value
            }
          }
        }
      }
    }
    if (loc != "" || this.selectedDataset['direction'] != "" || this.selectedDataset['body_part'] != null) {
      updateData['woundlocation'] = loc + (this.selectedDataset['direction'] === null ? "" : this.selectedDataset['direction']) + " " + (this.selectedDataset['body_part'] === null ? "" : this.selectedDataset['body_part'])
    }
    if (this.selectedStage != "") {
      updateData['severity'] = this.selectedStage;
    }
    updateData['woundNo'] = this.wound.woundNo;
    updateData['_id'] = this.wound._id;
    if (!(JSON.stringify(this.selectedDataset) === JSON.stringify(this.oldselectedDataset)) || !(JSON.stringify(this.oldselectedDatasetInLatestChildWound) === JSON.stringify(this.selectedDatasetInLatestChildWound))) {
      this.dialogRef.close({
        wound: this.wound,
        childWound: this.childWound,
        state: this.selectedState,
        stage: this.selectedStage,
        updateData
      });
    } else {
      this.dialogRef.close({
        wound: this.wound,
        childWound: this.childWound,
        state: this.selectedState,
        stage: this.selectedStage
      });
    }
  }

  showWoundICD10Dialog() {
    const dialogRef = this.dialog.open(WoundICD10DialogComponent, {
      width: 'auto',
      data: {
        patient: this.patient,
        provider: this.provider,
        wound: this.wound,
        etilogyGroup: this.dataset.find(column => this.getFieldName(column.header) === 'etiolgy'),
        selectedDataset: this.selectedDataset
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // https://doctornow.atlassian.net/browse/DUP-152
      this.initWoundDiagnosis();
      if (result) {


        this.wound.wound_diagnosis = result.woundDiagnosis._id;
        if (result.selectedWoundGroupDetailsICD) {
          this.onICDsSave.emit(Object.values(result.selectedWoundGroupDetailsICD).filter(e => !!e))
        }
      }
    });
  }
  changeDate(event: MatDatepickerInputEvent<Date>) {
    let date = moment(event.value);
    this.selectedDataset.wound_recognition_date = date;
  }

  hasLatestChildWound() {
    return this.childWound._id !== this.wound._id
  }

  shouldChildWoundColumn(header) {
    // console.log('shouldChildWoundColumn', header);
    if (!this.hasLatestChildWound()) return false;

    const fieldName = this.getFieldName(header);
    const fields = Object.keys(this.selectedDatasetInLatestChildWound);
    // console.log('shouldChildWoundColumn', {fields, 'fields.includes(fieldName);':  fields.includes(fieldName)});
    return fields.includes(fieldName);
  }

  isArchivedWound() {
    return this.wound.state === 'archived'
  }
  isEditingLocked() {
    // const isCreatedToday = moment(this.childWound.createdAt).startOf('day')
    // .isSame(moment().startOf('day'));
    // if(isCreatedToday) return false;

    if (this.childWound._most_recent_wound) return false;

    return true;
    // return false;
  }
  showAvatar() {
    this.avatar = !this.avatar;
    if (this.avatar) {
      this.avatarMsg = "Hide Avatar";
    } else {
      this.avatarMsg = "Show Avatar";
    }
  }
  getSelectedWoundICDs() {
    if (this.woundDiagnosis?.selected_data?.length > 0) {
      const icds = this.woundDiagnosis.selected_data.filter(data => data.icd_id).map(data => data.icd_id);
      return icds;
    }
    return [];
  }
  addNewFreeTextField(event: MatChipInputEvent, column, getValueUsingId = false, childData = false): void {
    let value = (event.value || '').trim();
    const headerRowsValues = column.rows.map((row)=> row.value);
    if(getValueUsingId){
      value = jQuery(`#${column._id}`).val().toString().trim();
    }
    let fieldName = this.getFieldName(column.header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if(childData){
      let rawValue = this.selectedDatasetInLatestChildWound[fieldName].trim();
      if (rawValue == "" || rawValue == " ") {
        this.selectedDatasetInLatestChildWound[fieldName] = value;
      } else {
        const rawAllValues = rawValue.split(", ");
        if(rawAllValues.findIndex((raw)=> raw.toLowerCase() === value.toLowerCase()) === -1){
          const headerRowValueIndex = headerRowsValues.findIndex((rvalue)=> rvalue.toLowerCase() === value.toLowerCase())
          if(headerRowValueIndex === -1){
            this.selectedDatasetInLatestChildWound[fieldName] = rawValue + ", " + value;
          }else{
            this.selectedDatasetInLatestChildWound[fieldName] = rawValue + ", " + headerRowsValues[headerRowValueIndex];
          }
        }
      }
    }else{
      let rawValue = this.selectedDataset[fieldName].trim();
      if (rawValue == "" || rawValue == " ") {
        this.selectedDataset[fieldName] = value;
      } else {
        const rawAllValues = rawValue.split(", ");
        if(rawAllValues.findIndex((raw)=> raw.toLowerCase() === value.toLowerCase()) === -1){
          const headerRowValueIndex = headerRowsValues.findIndex((rvalue)=> rvalue.toLowerCase() === value.toLowerCase())
          if(headerRowValueIndex === -1){
            this.selectedDataset[fieldName] = rawValue + ", " + value;
          }else{
            this.selectedDataset[fieldName] = rawValue + ", " + headerRowsValues[headerRowValueIndex];
          }
        }
      }
    }
    if(getValueUsingId){
      jQuery(`#${column._id}`).val("")
    }else{
      event.input.value = '';
    }
  }
  removeFreeTextField(valueRemove, column, childData = false) {
    let fieldName = this.getFieldName(column.header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if(childData){
      let rawValue = this.selectedDatasetInLatestChildWound[fieldName];
      const allValues = rawValue ? rawValue.split(", ").join(",").split(",") : [];
      allValues.forEach((value, index) => {
        if (value.trim() === valueRemove.trim()) {
          allValues.splice(index, 1);
        }
      });
      this.selectedDatasetInLatestChildWound[fieldName] = allValues.join(", ");
    }else{
      let rawValue = this.selectedDataset[fieldName];
      const allValues = rawValue ? rawValue.split(", ").join(",").split(",") : [];
      allValues.forEach((value, index) => {
        if (value.trim() === valueRemove.trim()) {
          allValues.splice(index, 1);
        }
      });
      this.selectedDataset[fieldName] = allValues.join(", ");
    }
  }
  extractMultiselectCustomValues(column, childData = false) {
    let fieldName = this.getFieldName(column.header);
    if (fieldName === 'wound_edges') {
      fieldName = 'exposed_structure';
    } else if (fieldName === 'exudate_amount') {
      fieldName = 'exudate';
    } else if (fieldName === 'wound_odor') {
      fieldName = 'odor';
    }
    if(childData){
      let rawValue = this.selectedDatasetInLatestChildWound[fieldName];
      const allValues = rawValue ? rawValue.split(", ").join(",").split(",") : [];
      const valuesToRemove = column.rows.map(row => row.value);
      // remove all occurances of each item in valuesToRemove from allValues
      for (let i = 0; i < valuesToRemove.length; i++) {
        const valueToRemove = valuesToRemove[i];
        allValues.forEach((value, index) => {
          if (typeof (valueToRemove) === "string" && value.trim() === valueToRemove.trim()) {
            allValues.splice(index, 1);
          } else if (value === '') {
            allValues.splice(index, 1);
          }
        })
      }
      return allValues;
    }else{
      let rawValue = this.selectedDataset[fieldName];
      const allValues = rawValue ? rawValue.split(", ").join(",").split(",") : [];
      const valuesToRemove = column.rows.map(row => row.value);
      // remove all occurances of each item in valuesToRemove from allValues
      for (let i = 0; i < valuesToRemove.length; i++) {
        const valueToRemove = valuesToRemove[i];
        allValues.forEach((value, index) => {
          if (typeof (valueToRemove) === "string" && value.trim() === valueToRemove.trim()) {
            allValues.splice(index, 1);
          } else if (value === '') {
            allValues.splice(index, 1);
          }
        })
      }
      return allValues;
    }
  }
}